import { useState } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../../../store/reducers/rootReducer'
import selectBrodMigdal from '../../../../../../generic/utils/selectBrodMigdal'
import WarehouseSelector from '../../../../../../generic/ui/Selectors/WarehouseSelector'
import FormField from '../../../../../../generic/ui/FormLayout/FormField'
import { FileUploadPanel } from '../../../../../../generic/ui/FileUpload'
import { IWarhouseListItem } from '../../../../../../modules/API/Defaults/models/warhouseList'

export interface LocationUploadPanelProps {
  accept: string[]
  warehouses: IWarhouseListItem[]
  onUpload: (file: File, warehouseId: number) => Promise<unknown>
  /** Injected by AppModal. */
  closeFunc?: () => void
}

/**
 * Upload-modal content for the locations import: a warehouse selector on top
 * (defaulted from brodMigdal 5) over the untouched reusable FileUploadPanel.
 */
const LocationUploadPanel = ({ accept, warehouses, onUpload, closeFunc }: LocationUploadPanelProps) => {
  const defaults = useSelector((state: RootState) => state.defaults.defaults)
  const defaultWarehouseId = selectBrodMigdal(defaults, 5, 'Num_Value')
  const [selectedId, setSelectedId] = useState<number | null>(null)

  // Reactive to defaults arriving after mount; 0 means "no warehouse chosen".
  const warehouseId = selectedId ?? (Number(defaultWarehouseId) || 0)
  const selectedWarehouse = warehouses.find((w) => w.WarehouseID === warehouseId) ?? null

  // The panel renders a rejection as its error card — no toast needed here.
  const handleUpload = (file: File) => {
    if (!warehouseId) return Promise.reject(new Error('יש לבחור מחסן'))
    return onUpload(file, warehouseId)
  }

  return (
    <Panel>
      <FormField label='מחסן' required>
        <WarehouseSelector
          warehouses={warehouses}
          value={selectedWarehouse}
          onSelect={(warehouse) => setSelectedId(warehouse?.WarehouseID ?? null)}
        />
      </FormField>
      <FileUploadPanel accept={accept} onUpload={handleUpload} closeFunc={closeFunc} />
    </Panel>
  )
}

export default LocationUploadPanel

const Panel = styled.div`
  direction: rtl;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`
